import QRCode from "qrcode";

/**
 * Generates a QR code as a data URL (base64 PNG).
 */
export async function generateQRDataUrl(text: string, size = 200): Promise<string> {
  return QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    color: { dark: "#000000", light: "#ffffff" },
    errorCorrectionLevel: "M",
  });
}

/**
 * Downloads the QR as a PNG file.
 */
export function downloadQRImage(dataUrl: string, filename: string): void {
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `${filename}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Prints a QR label using a hidden iframe (no new tab).
 */
export function printQRLabel(dataUrl: string, code: string, label: string): void {
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "-9999px";
  iframe.style.left = "-9999px";
  iframe.style.width = "0";
  iframe.style.height = "0";
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument ?? iframe.contentWindow?.document;
  if (!doc) { document.body.removeChild(iframe); return; }

  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${code}</title>
      <style>
        @page { margin: 0; size: auto; }
        body { margin: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; font-family: system-ui, sans-serif; }
        img { width: 300px; height: 300px; }
        .code { font-size: 20px; font-weight: 700; margin-top: 16px; }
        .label { font-size: 14px; color: #666; margin-top: 6px; }
      </style>
    </head>
    <body>
      <img src="${dataUrl}" />
      <div class="code">${code}</div>
      <div class="label">${label}</div>
    </body>
    </html>
  `);
  doc.close();

  iframe.onload = () => {
    iframe.contentWindow?.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };
}
